// Photo Gallery — official Instagram posts from Jay Ambe Jyotish
// Add more entries as new posts are uploaded.
//
// Each entry: { src, alt, span? }
// `span` controls layout in the masonry grid:
//   "tall" → occupies 2 rows (portrait)
//   "wide" → occupies 2 columns (landscape)
//   "huge" → 2×2
export const galleryImages = [
  {
    src: "https://customer-assets.emergentagent.com/job_celestial-premium-1/artifacts/hr7uk4cs_1000046014.jpg.jpeg",
    alt: "Jay Ambe Jyotish — Vashikaran & Love Problem Specialist · Adajan, Surat",
    span: "huge",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_celestial-premium-1/artifacts/4wrrs1rb_IMG_20250605_213439_258.jpg.jpeg",
    alt: "Premium Guaranteed Vashikaran & Love Problem Specialist — 24×7 available",
    span: "huge",
  },
];
